import { SystemBase } from "@inter-ikea-core/core-toolbox";
import CalculateCrossBraceComponent from "../components/CalculateCrossBraceComponent";
import { RIGHT } from "../constants";
import { getAttachedToRecursively } from "../functions/attachedTo";
import { attachOrDetachCrossBraceByIndex } from "../functions/calculateCrossBrace";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
export class CrossBraceCalculationSystem extends SystemBase {
    constructor(entityManager, productManager, coreServices) {
        super(COMPONENT_IDS.CALCULATE_CROSS_BRACE);
        this.entityManager = entityManager;
        this.productManager = productManager;
        this.coreServices = coreServices;
        this.doingChangesOnComponent = [
            CalculateCrossBraceComponent.id,
        ];
        this.id = "CrossBraceCalculationSystem";
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        const allAttachments = getAttachedToRecursively({
            entity: _entity,
            direction: RIGHT,
        });
        _entity.removeComponent(COMPONENT_IDS.CALCULATE_CROSS_BRACE);
        attachOrDetachCrossBraceByIndex([_entity, ...allAttachments], this.coreServices);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, _oldComponent) {
        logEmptyFunctionWarning("onRemoveComponent", this.id);
    }
}
